import { useAppSelector } from '../../../../configuration/setup/hooks';
import { getLocale } from '../../../../configuration/lang/langSlice';
import { getTenant } from '../../../../configuration/tokenHandling/tokenHandlingSlice';

const EUROPE_TENANT_PREFIX = 'rio-eu';

export const ContactButton = () => {
    const tenant = useAppSelector(getTenant);
    const locale = useAppSelector((state) => getLocale(state) ?? 'en-GB');

    // eslint-disable-next-line
    const hostnameEncoded = encodeURIComponent(document.referrer);
    return tenant?.startsWith(EUROPE_TENANT_PREFIX) ? (
        <div data-testid={'contact-button'}>
            <iframe
                className="buyButton height-30 padding-top-5 padding-bottom-5"
                title="ContactForm"
                src={`https://contact-form.rio.cloud/contact_link.html?opener=${hostnameEncoded}&locale=${locale}`}
            />
        </div>
    ) : null;
};
